export default {"src":"/_next/static/media/signout.df4c6f88.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};